// src/pages/NotFoundPage.jsx
import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import OuterContainer from "../components/layout/OuterContainer";
import { connect } from "react-redux";
import styled, { keyframes } from "styled-components";
import Meta from "../components/Meta";
import colors from "../utils/constants/colors";

/* =============================== Styling only =============================== */

const AuthBg = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #f7f9fc 0%, #f1f5fb 60%, #eef3fb 100%);
  padding-top: 64px; /* space for NavBar */
  display: flex;
  align-items: center;
  justify-content: center;
`;

/* ───────── Animations ───────── */
const float = keyframes`
  0%   { transform: translateY(0px); }
  50%  { transform: translateY(-8px); }
  100% { transform: translateY(0px); }
`;

const NotFoundContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e9eef6;
  border-radius: 16px;
  margin: 48px auto;
  width: 600px;
  max-width: 95%;
  padding: 48px 40px;
  box-shadow: 0 12px 28px rgba(2, 8, 23, 0.06), 0 2px 8px rgba(2, 8, 23, 0.04);
  text-align: center;
`;

const Header = styled.h1`
  margin: 0 0 16px 0;
  font-size: clamp(48px, 8vw, 72px);
  font-weight: 900;
  letter-spacing: -0.02em;
  color: ${colors.primary};
  animation: ${float} 3s ease-in-out infinite;
`;

const SubHeader = styled.h2`
  margin: 0 0 8px 0;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.2px;
  color: #0f172a;
`;

const Description = styled.p`
  margin: 0 0 32px 0;
  font-size: 16px;
  color: #64748b;
  line-height: 1.6;
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
`;

const Button = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  border-radius: 10px;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.2s ease;
  font-size: 14px;
`;

const PrimaryButton = styled(Button)`
  background: linear-gradient(135deg, #3b82f6 0%, #6366f1 100%);
  color: white !important;
  border: none;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.25);
    color: white !important;
  }
`;

const SecondaryButton = styled(Button)`
  background: white;
  color: #475569;
  border: 1px solid #e9eef6;

  &:hover {
    background: #f8fafc;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const Footer = styled.div`
  font-size: 14px;
  color: #64748b;
  padding-top: 24px;
  border-top: 1px solid #eef2f7;
`;

/* =============================== Component =============================== */

const NotFoundPage = (props) => {
  return (
    <Meta pageMeta={{ title: "Page Not Found - Doitly" }}>
      <NavBar user={props.state.user} />
      <AuthBg>
        <OuterContainer>
          <NotFoundContainer>
            <Header>404</Header>
            <SubHeader>Page Not Found</SubHeader>
            <Description>
              The page you're looking for doesn't exist or has been moved.
              Let's get you back on track!
            </Description>

            <Actions>
              <PrimaryButton to="/">Go Home</PrimaryButton>
              <SecondaryButton to="/tasks">Browse Tasks</SecondaryButton>
              <SecondaryButton to="/usertasks">My Dashboard</SecondaryButton>
            </Actions>

            <Footer>
              Need help? Try checking the URL or contact support if the problem persists.
            </Footer>
          </NotFoundContainer>
        </OuterContainer>
      </AuthBg>
    </Meta>
  );
};

const mapStateToProps = (state) => ({ state });
export default connect(mapStateToProps, null)(NotFoundPage);
